import { effects } from 'redux-saga';
import { LanguageSwitcherReduxTypes } from './languageSwitcherRedux';
import { getCurrentPath } from '../../helpers/utility';
import { push } from 'react-router-redux';

export const currentLanguageFnc = state => state.Language.language;
export const currentLanguageRfc3066Fnc = state => state.Language.language;

export function* changeLanguage(action) {
  const path = getCurrentPath();
  console.log(
    '[CHANGE_LANGUAGE] current path is :',
    path,
    ' action is :',
    action
  );
  const pathArray: string[] = path.split('/');
  const langInPath = pathArray[0];
  if (langInPath !== action.language) {
    pathArray[0] = action.language;
    const newLocation = `/${pathArray.join('/')}`;
    yield effects.put(push(newLocation)); 
  }
}

export default function* rootSaga() {
  yield effects.all([
    effects.takeLatest(
      LanguageSwitcherReduxTypes.CHANGE_LANGUAGE,
      changeLanguage
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/languageSwitcher/languageSwitcherSaga.ts